import { defineStore } from "pinia";
import type { User } from "@/types";
import parseJwt from "../utils/parseJwt";
import { authApiInstance } from "../services/api";
import * as Sentry from '@sentry/vue'


export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    isLoading: false,
    isError: false,
    isLoggedIn: localStorage.getItem("token") || null,
    onBoardingStatus: "",
    companyId: localStorage.getItem("companyId") || null,
    user: (JSON.parse(localStorage.getItem("user") || "null") as User) || null,
    returnUrl: "/",
  }),
  getters: {
    loading: (state) => state.isLoading,
    error: (state) => state.isError,
    getUser: (state) => state.user,
  },
  actions: {
    async logout() {
      const accessToken = localStorage.getItem("token");
      const refreshToken = localStorage.getItem("refreshToken");
      const idToken = localStorage.getItem("idToken");
      const decodeToken = idToken ? parseJwt(idToken) : null;
      const email = decodeToken?.email || '';
      Sentry.setUser(null)

      try {

        const response = await authApiInstance.post(`/auth/sign-out`, {
          accessToken: refreshToken || accessToken || null,
          idpDomain: email?.includes('@') ? email.split('@')[1] : null
        });

        console.log("Logout response: ", response.data);

        // Preserve redirectPath, locale, while clearing auth data
        const redirectPath = localStorage.getItem('redirectPath');
        const locale = localStorage.getItem('locale');
        const formId = localStorage.getItem('formId');
        
        // Clear specific auth-related keys instead of clearing all localStorage
        localStorage.removeItem('companyId');
        localStorage.removeItem('dataPolicies');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Restore preserved values
        if (redirectPath) localStorage.setItem('redirectPath', redirectPath);
        if (locale) localStorage.setItem('locale', locale);
        if (formId) localStorage.setItem('formId', formId);
        
        //@ts-ignore
        this.user = null;

        window.location.href = response.data || import.meta.env.VITE_AUTH_APP_URL + "/sign-out";

      } catch (error) {
        console.error("Logout failed:", error);

        // Preserve redirectPath, locale while clearing auth data
        const redirectPath = localStorage.getItem('redirectPath');
        const locale = localStorage.getItem('locale');
        const formId = localStorage.getItem('formId');
        
        // Clear specific auth-related keys instead of clearing all localStorage
        localStorage.removeItem('companyId');
        localStorage.removeItem('dataPolicies');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Restore preserved values
        if (redirectPath) localStorage.setItem('redirectPath', redirectPath);
        if (locale) localStorage.setItem('locale', locale);
        if (formId) localStorage.setItem('formId', formId);
        
        //@ts-ignore
        this.user = null;
        window.location.replace(import.meta.env.VITE_AUTH_APP_URL + "/sign-out");
      }
    }
  },
});
